export enum Frequency {    
    Daily = 5,
    Weekly = 10,
    Monthly = 15,
    Yearly = 20
}